var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35003 16.7368C8.92535 16.7368 8.54248 16.9933 8.37996 17.3866C8.21744 17.78 8.30727 18.2327 8.60757 18.5338L11.7575 21.6917C11.9545 21.8891 12.2215 22 12.5 22C12.7786 22 13.0456 21.8891 13.2425 21.6917L16.3925 18.5338C16.6928 18.2327 16.7826 17.78 16.6201 17.3866C16.4576 16.9932 16.0747 16.7368 15.65 16.7368H9.35003Z",
    fill: "#1C459B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 2C4.35051 2 2 4.3564 2 7.26316V13.5789C2 16.4857 4.35051 18.8421 7.25 18.8421H17.75C20.6495 18.8421 23 16.4857 23 13.5789V7.26316C23 4.3564 20.6495 2 17.75 2H7.25Z",
    fill: "#1C459B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2 8.31582C6.2 7.73447 6.6701 7.26318 7.25 7.26318H15.65C16.2299 7.26318 16.7 7.73447 16.7 8.31582C16.7 8.89716 16.2299 9.36845 15.65 9.36845H7.25C6.6701 9.36845 6.2 8.89716 6.2 8.31582Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2 12.5263C6.2 11.9449 6.6701 11.4736 7.25 11.4736H17.75C18.3299 11.4736 18.8 11.9449 18.8 12.5263C18.8 13.1076 18.3299 13.5789 17.75 13.5789H7.25C6.6701 13.5789 6.2 13.1076 6.2 12.5263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.20e2885f58baed5f14ac88fc0297e276.svg";
export { ForwardRef as ReactComponent };